import React from "react";
import { NavLink } from "react-router-dom";
const $ = window.$;

class Header extends React.Component {
  componentDidMount() {
    $(".ui.dropdown").dropdown();
  }

  render() {
    return (
      <div
        className="ui top fixed menu"
        style={{ marginBottom: "0", paddingBottom: "3px" }}
      >
        <NavLink to="/" className="item" exact>
          Home
        </NavLink>
        <div className="ui dropdown item">
          All Application
          <i className="dropdown icon"></i>
          <div className="menu">
            <NavLink to="/passsguard" className="item">
              PasssGuard
            </NavLink>
            <NavLink to="/spendguard" className="item">
              SpendGuard
            </NavLink>
            <NavLink to="/carpark" className="item">
              CarParkSG
            </NavLink>
            <NavLink to="/gameguard" className="item">
              GameGuard
            </NavLink>
            <NavLink to="/transportguard" className="item">
              Transport Guard
            </NavLink>
            <NavLink to="/footagedoctor" className="item">
              Footage Doctor
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
